class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    console.log("test");

    const swiper = new Swiper(".top-mv-swiper", {
      loop: true,
      effect: 'fade',
      speed: 800,
      autoplay: {     //追記
        delay: 3000,   //追記
      },
      allowTouchMove: false,
    });

  }
}